const PRINCIPLE_TO_CANNED_QUERY: Record<string, string> = {
  development: 'Development',
  centercontrol: 'Center Control',
  kingsafety: 'King Safety',
  pawncoordination: 'Pawn Coordination',
  pieceactivity: 'Piece Activity',
  pieceequality: 'Piece Equality',
  castling: 'Castling',
  rooksconnection: 'Rook Connection',
  initiative: 'Initiative',
};

const normalize = (value: string) =>
  String(value || '')
    .replace(/[^a-zA-Z]/g, '')
    .toLowerCase();

export function oirPrincipleToCannedQuery(principle?: string): string {
  if (!principle) {
    return 'All';
  }

  const normalized = normalize(principle);
  const mapped = PRINCIPLE_TO_CANNED_QUERY[normalized];
  if (mapped) {
    return mapped;
  }

  // Fallback keeps wording human-readable and lets backend resolve if supported.
  return String(principle).replace(/_/g, ' ').trim() || 'All';
}

